module.exports = new __parcel__URL__("crypto.e660190f.png").toString();